import React from 'react';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '../../Constants/Colors';

const useStyles = makeStyles({
  root: {
    color: red,
  },
});

interface SubtitleProps {
  className: string;
  children: React.ReactNode;
}

export const Subtitle: React.FC<SubtitleProps> = ({ className, ...props }) => {
  const classes = useStyles();
  return <Typography variant={'subtitle1'} className={clsx(classes.root, className)} {...props} />;
};

export default Subtitle;
